import type { Settings, User, UserMe } from '@types'
import axios from 'axios'

import env from '../environments'

export async function getMe() {
	const response = (await axios.get(`${env.apiUrl}/users/me`))

	return response.data as UserMe
}

export async function updateUser(user: Partial<User>) {
	await axios.put(`${env.apiUrl}/users`, user)
}

export async function updateSettings(settings: Settings) {
	await axios.put(`${env.apiUrl}/users/settings`, settings)
}

export async function getCompanyUsers() {
	const response = await axios.get(`${env.apiUrl}/users/company`)

	return response.data as User[]
}
